import { render, staticRenderFns } from "./ResettingPassword.vue?vue&type=template&id=1e83c23b&scoped=true&lang=pug"
import script from "./ResettingPassword.vue?vue&type=script&lang=js"
export * from "./ResettingPassword.vue?vue&type=script&lang=js"
import style0 from "./ResettingPassword.vue?vue&type=style&index=0&id=1e83c23b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e83c23b",
  null
  
)

export default component.exports